import type { ComponentProps, ComponentType } from 'react';
import Common from '@/components/ModalRenderer/components';
import FI from '@/components/ModalRenderer/components/FI';
import SE from '@/components/ModalRenderer/components/SE';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import UK from '@/components/ModalRenderer/components/UK';

type PrefixedKeys<Prefix extends string, Map extends Record<string, unknown>> = {
  [K in keyof Map as K extends string ? `${Prefix}.${K}` : never]: Map[K];
};

const prefixKeys = <Prefix extends string, Map extends Record<string, unknown>>(
  prefix: Prefix,
  map: Map,
): PrefixedKeys<Prefix, Map> =>
  Object.fromEntries(Object.entries(map).map(([key, value]) => [`${prefix}.${key}`, value])) as PrefixedKeys<
    Prefix,
    Map
  >;

const modalMap = {
  ...Common,
  ...prefixKeys('FI', FI),
  ...prefixKeys('SE', SE),
  ...prefixKeys('UK', UK),
};

type ModalMap = typeof modalMap;
export type ModalTypes = keyof ModalMap;

export type ModalPayload<T extends ModalTypes> =
  ComponentProps<ModalMap[T]> extends {
    payload: infer P;
  }
    ? P
    : undefined;

export type ModalComponent = ComponentType<ModalProps<unknown>>;

export default modalMap;
